'use client';

import * as SheetPrimitive from '@radix-ui/react-dialog';

const SheetPortal = SheetPrimitive.Portal;

export { SheetPortal };
